// Mock data for QuartierEnergie Landing Page

export const heroData = {
  headline: "Das Wohnquartier der Zukunft produziert, speichert und vermarktet Energie selbst.",
  subheadline: "Wir entwickeln wirtschaftlich rentable Wohnquartiere mit integrierten Batteriespeichern, die Energiekosten senken, ESG-Ziele erfüllen und neue Erlöse schaffen.",
  ctaText: "Kostenlose Projekt-Erstbewertung anfordern",
  trustBadges: [
    { label: "ESG-konform", icon: "Leaf" },
    { label: "Förderfähig", icon: "BadgeEuro" },
    { label: "Skalierbar", icon: "TrendingUp" },
    { label: "Technologie-agnostisch", icon: "Settings" }
  ]
};

export const problemsData = [
  { title: "Volatile Strompreise", icon: "TrendingDown" },
  { title: "Hohe Nebenkosten", icon: "Receipt" },
  { title: "Fehlende Netzkapazitäten", icon: "PlugZap" },
  { title: "Unklare Regulierung", icon: "FileQuestion" }
];

export const solutionData = {
  title: "Die Lösung",
  description: "Ein integriertes Quartiers-Energiesystem aus Photovoltaik, Batteriespeicher und intelligentem Energiemanagement.",
  flowSteps: [
    { label: "PV-Anlage", icon: "Sun" },
    { label: "BESS", icon: "Battery" },
    { label: "Quartier", icon: "Building2" },
    { label: "Markt", icon: "BarChart3" }
  ]
};

export const valuePropositions = [
  {
    icon: "BatteryCharging",
    title: "Bis zu 40% niedrigere Energiekosten",
    description: "Durch Eigenverbrauchsoptimierung und intelligentes Lastmanagement."
  },
  {
    icon: "TrendingUp",
    title: "Wertsteigerung der Immobilie",
    description: "ESG-Bonus und höhere Attraktivität für nachhaltigkeitsbewusste Mieter."
  },
  {
    icon: "Zap",
    title: "Zusätzliche Erlöse",
    description: "Durch Energievermarktung und Flexibilitätsbereitstellung am Markt."
  },
  {
    icon: "Globe",
    title: "Zukunftssicher & robust",
    description: "Regulatorisch abgesichert und technologisch auf dem neuesten Stand."
  }
];

export const capabilities = [
  { icon: "LayoutGrid", title: "Quartiers-Energiekonzepte", description: "Ganzheitliche Planung für optimale Energieflüsse" },
  { icon: "Battery", title: "BESS-Integration", description: "Professionelle Batteriespeicher-Einbindung" },
  { icon: "Home", title: "Mieterstrom", description: "Eigenverbrauchsoptimierung für alle Parteien" },
  { icon: "Activity", title: "Regelleistung", description: "Flexibilitätsvermarktung für Zusatzerlöse" },
  { icon: "Coins", title: "Finanzierung", description: "Fördermittel- und Finanzierungsstruktur" },
  { icon: "MonitorCheck", title: "Betrieb & Monitoring", description: "24/7 Überwachung und Optimierung" }
];

export const economicsData = [
  { value: "6–9", unit: "Jahre", label: "ROI", icon: "TrendingUp" },
  { value: "200.000", unit: "€/Jahr", label: "Zusatzerlöse", icon: "Euro" },
  { value: "70", unit: "%", label: "Autarkiegrad", icon: "Gauge" }
];

export const targetAudience = [
  { title: "Projektentwickler", icon: "HardHat", description: "Für Neubau- und Sanierungsprojekte" },
  { title: "Investoren", icon: "Briefcase", description: "Family Offices & ESG-fokussierte Anleger" },
  { title: "Wohnungsunternehmen", icon: "Building", description: "Wohnungsbaugesellschaften" },
  { title: "Kommunen & Stadtwerke", icon: "Landmark", description: "Öffentliche Auftraggeber" }
];

export const processSteps = [
  { step: "01", title: "Analyse", description: "Detaillierte Potenzialanalyse Ihres Projekts" },
  { step: "02", title: "Konzept & Wirtschaftlichkeit", description: "Maßgeschneidertes Energiekonzept mit klarer Kalkulation" },
  { step: "03", title: "Umsetzung & Betrieb", description: "Realisierung und langfristiger Betrieb aus einer Hand" }
];

export const trustPoints = [
  "Technologie-Partner auf Tier-1-Niveau",
  "Langfristige Betriebsmodelle",
  "Regulatorische Expertise"
];

export const projectStatusOptions = [
  { value: "planning", label: "In Planung" },
  { value: "concept", label: "Konzeptphase" },
  { value: "construction", label: "Im Bau" },
  { value: "existing", label: "Bestandsquartier" },
  { value: "other", label: "Sonstiges" }
];

export const footerData = {
  companyDescription: "city-battery.energy entwickelt zukunftssichere Energielösungen für Wohnquartiere. Wir verbinden Photovoltaik, Batteriespeicher und intelligentes Energiemanagement zu einem wirtschaftlich rentablen Gesamtsystem.",
  contactEmail: "info@city-battery.energy",
  linkedInUrl: "https://linkedin.com/company/city-battery-energy",
  links: [
    { label: "Impressum", href: "/impressum" },
    { label: "Datenschutz", href: "/datenschutz" },
    { label: "Barrierefreiheit", href: "/barrierefreiheit" }
  ]
};
